jQuery(document).ready( function () {
    jQuery(".wc-tabs a").click(function( event ) {
        event.preventDefault();
    });

    // Add smooth scrolling to all links
  jQuery("a").on('click', function(event) {
        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "") {
        // Prevent default anchor click behavior
        event.preventDefault();

        // Store hash
        var hash = this.hash;

        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        jQuery('html, body').animate({
            scrollTop: jQuery(hash).offset().top}, 1200, function(){

            // Add hash (#) to URL when done scrolling (default click behavior)
            window.location.hash = hash;
        });
        } // End if
    });
if(jQuery('#menu').length){
    jQuery('#menu').DataTable({
        "paging": false,
        "order" : [[0, "asc"]],
        "dom": '<"st-top"f>rt<"st-bottom"lip>',
        initComplete: function () {
            this.api().columns([2]).every( function () {
                var column = this;
                var select = jQuery('<div id="drink-select" class="small-12 large-3 column"><select class="drink-box"><option value="">All Drinks</option></select></div>')
                .appendTo( jQuery('.st-top') );
                
                select.children('.drink-box')
                .on( 'change', function () {
                    column.search(this.value).draw();
                } );
                
                select.children('.drink-box').append( '<option value="milk-tea">Milk Tea</option>' );
                select.children('.drink-box').append( '<option value="fruit-tea">Fruit Tea</option>' );
                select.children('.drink-box').append( '<option value="slush">Slush</option>' );
                select.children('.drink-box').append( '<option value="smoothie">Smoothie</option>' );
                jQuery('.st-bottom').empty();
                
            } );
        },
        "oLanguage": {
            
            "sSearch": "",
            "sSearchPlaceholder": "Type to search for a drink",
        },
        "columnDefs": [
            {
                "targets": [ 2 ],
                "visible": false,
                "searchable": true
            },
        ],
    });
}
    
        jQuery('#menu_filter').addClass('small-12').addClass('large-3').addClass('column');
        var table = jQuery('#shop .products');
        
        if(table.length){

            table.DataTable({
                "pagingType": "full_numbers",
                "lengthMenu": [ 9, 18, 24],
                "order" : [[0, "asc"]],
                "dom": '<"st-top"f>rt<"st-bottom"lip>',
                initComplete: function () {
                    
                    var select = jQuery('#category-filter');
                    var table = this;
                    this.api().columns([4]).every( function () {
                        var column = this;
                        select.on( 'change', function () {
                            column.search(this.value).draw();
                            console.log(table);
                            // if(select.val() == 'all'){
                                //     table.draw( false );
                                // }
                            } );
                            
                        });
                        // this.api().columns(5,6).every( function () {
                            
                            // });
                        },
                        "oLanguage": {
                            
                            "sSearch": "",
                            "sSearchPlaceholder": "Type to search for a product",
                        },
                        "columnDefs": [
                            {
                                "targets": [ 4 ],
                                "visible": false,
                                "searchable": true
                            },
                        ],
                        "drawCallback": function( settings ) {
                            jQuery("#shop .products thead").remove();
                            
                        },
                        // "fnDrawCallback": 
                    });
                    
                }
                    // jQuery(document).ready(function($) {
                        //     var $lt_slides = '';
                        //     $lt_slides = jQuery('#locations-tab .lt-tabs');
                        //     if (0 < $lt_slides.length) {
                            //         $lt_slides.slick({
    //             // accessibility: true, // type:boolean, default:true, Enables tabbing and arrow key navigation
    //             // adaptiveHeight: false, // type:boolean, default:false, Enables adaptive height for single slide horizontal carousels.
    //             // autoplay: false, // type:boolean, default:false, Enables Autoplay
    //             // autoplaySpeed: 3000, // type:int(ms), default:3000, Autoplay Speed in milliseconds
    //             arrows: false, // type:boolean, default:true, Prev/Next Arrows
    //             asNavFor: '.lt-selectors', // type:string, default:null, Set the slider to be the navigation of other slider (Class or ID Name)
    //             // appendArrows: $(element), // type:string, default:$(element), Change where the navigation arrows are attached (Selector, htmlString, Array, Element, jQuery object)
    //             // appendDots: $(element), // type:string, default:$(element), Change where the navigation dots are attached (Selector, htmlString, Array, Element, jQuery object)
    //             // prevArrow: , // type:string (html|jQuery selector) | object (DOM node|jQuery object), default:&lt;button type="button" class="slick-prev"&gt;Previous&lt;/button&g&lt;button type="button" class="slick-prev"&gt;Previous&lt;/button&gt;t;, Allows you to select a node or customize the HTML for the "Previous" arrow.
    //             // nextArrow: , // type:string (html|jQuery selector) | object (DOM node|jQuery object), default:&lt;button type="button" class="slick-next"&gt;Next&lt;/button&g&lt;button type="button" class="slick-next"&gt;Next&lt;/button&gt;t;, Allows you to select a node or customize the HTML for the "Next" arrow.
    //             // centerMode: true, // type:boolean, default:false, Enables centered view with partial prev/next slides. Use with odd numbered slidesToShow counts.
    //             // centerPadding: '50px', // type:string, default:'50px', Side padding when in center mode (px or %)
    //             // cssEase: 'ease', // type:string, default:'ease', CSS3 Animation Easing
    //             // customPaging: n/a, // type:function, default:n/a, Custom paging templates. See source for use example.
    //             dots: false, // type:boolean, default:false, Show dot indicators
    //             // dotsClass: 'slick-dots', // type:string, default:'slick-dots', Class for slide indicator dots container
    //             // draggable: true, // type:boolean, default:true, Enable mouse dragging
    //             // fade: false, // type:boolean, default:false, Enable fade
    //             // focusOnSelect: false, // type:boolean, default:false, Enable focus on selected element (click)
    //             // easing: 'linear', // type:string, default:'linear', Add easing for jQuery animate. Use with easing libraries or default easing methods
    //             // edgeFriction: 0.15, // type:integer, default:0.15, Resistance when swiping edges of non-infinite carousels
    //             // infinite: true, // type:boolean, default:true, Infinite loop sliding
    //             // initialSlide: 0, // type:integer, default:0, Slide to start on
    //             // lazyLoad: 'ondemand', // type:string, default:'ondemand', Set lazy loading technique. Accepts 'ondemand' or 'progressive' To use lazy loading, set a data-lazy attribute on your img tags and leave off the src
    //             mobileFirst: true, // type:boolean, default:false, Responsive settings use mobile first calculation
    //             // pauseOnFocus: true, // type:boolean, default:true, Pause Autoplay On Focus
    //             // pauseOnHover: true, // type:boolean, default:true, Pause Autoplay On Hover
    //             // pauseOnDotsHover: false, // type:boolean, default:false, Pause Autoplay when a dot is hovered
    //             // respondTo: 'window', // type:string, default:'window', Width that responsive object responds to. Can be 'window', 'slider' or 'min' (the smaller of the two)
    //             // responsive: none, // type:object, default:none, Object containing breakpoints and settings objects (see demo). Enables settings sets at given screen width. Set settings to "unslick" instead of an object to disable slick at a given breakpoint.
    //             // responsive: [
    //             // 	{
    //             // 		breakpoint: 481, // medium up
    //             // 		settings: {
    //             // 			slidesToShow: 3,
    //             // 		}
    //             // 	},
    //             // 	{
    //             // 		breakpoint: 769, // large up
    //             // 		settings: {
    //             // 			slidesToShow: 4,
    //             // 		}
    //             // 	},
    //             // ],
    //             // rows: 1, // type:int, default:1, Setting this to more than 1 initializes grid mode. Use slidesPerRow to set how many slides should be in each row.
    //             // slide: '', // type:element, default:'', Element query to use as slide
    //             // slidesPerRow: 1, // type:int, default:1, With grid mode intialized via the rows option, this sets how many slides are in each grid row. dver
    //             slidesToShow: 1, // type:int, default:1, # of slides to show
    //             // slidesToScroll: 1, // type:int, default:1, # of slides to scroll
    //             // speed: 300, // type:int(ms), default:300, Slide/Fade animation speed
    //             // swipe: true, // type:boolean, default:true, Enable swiping
    //             // swipeToSlide: false, // type:boolean, default:false, Allow users to drag or swipe directly to a slide irrespective of slidesToScroll
    //             // touchMove: true, // type:boolean, default:true, Enable slide motion with touch
    //             // touchThreshold: 5, // type:int, default:5, To advance slides, the user must swipe a length of (1/touchThreshold) * the width of the slider
    //             // useCSS: true, // type:boolean, default:true, Enable/Disable CSS Transitions
    //             // useTransform: true, // type:boolean, default:true, Enable/Disable CSS Transforms
    //             // variableWidth: false, // type:boolean, default:false, Variable width slides
    //             // vertical: false, // type:boolean, default:false, Vertical slide mode
    //             // verticalSwiping: false, // type:boolean, default:false, Vertical swipe mode
    //             // rtl: false, // type:boolean, default:false, Change the slider's direction to become right-to-left
    //             // waitForAnimate: true, // type:boolean, default:true, Ignores requests to advance the slide while animating
    //             // zIndex: 1000, // type:number, default:1000, Set the zIndex values for slides, useful for IE9 and lower
    //         });
    //     }
    // });
    // jQuery(document).ready(function($) {
    //     var $lt_tabs = '';
    //     $lt_tabs = jQuery('#locations-tab .lt-selectors');
    //     if (0 < $lt_tabs.length) {
    //         $lt_tabs.slick({
    //             // accessibility: true, // type:boolean, default:true, Enables tabbing and arrow key navigation
    //             // adaptiveHeight: false, // type:boolean, default:false, Enables adaptive height for single slide horizontal carousels.
    //             // autoplay: false, // type:boolean, default:false, Enables Autoplay
    //             // autoplaySpeed: 3000, // type:int(ms), default:3000, Autoplay Speed in milliseconds
    //             arrows: false, // type:boolean, default:true, Prev/Next Arrows
    //             asNavFor: '.lt-tabs', // type:string, default:null, Set the slider to be the navigation of other slider (Class or ID Name)
    //             // appendArrows: $(element), // type:string, default:$(element), Change where the navigation arrows are attached (Selector, htmlString, Array, Element, jQuery object)
    //             // appendDots: $(element), // type:string, default:$(element), Change where the navigation dots are attached (Selector, htmlString, Array, Element, jQuery object)
    //             // prevArrow: , // type:string (html|jQuery selector) | object (DOM node|jQuery object), default:&lt;button type="button" class="slick-prev"&gt;Previous&lt;/button&g&lt;button type="button" class="slick-prev"&gt;Previous&lt;/button&gt;t;, Allows you to select a node or customize the HTML for the "Previous" arrow.
    //             // nextArrow: , // type:string (html|jQuery selector) | object (DOM node|jQuery object), default:&lt;button type="button" class="slick-next"&gt;Next&lt;/button&g&lt;button type="button" class="slick-next"&gt;Next&lt;/button&gt;t;, Allows you to select a node or customize the HTML for the "Next" arrow.
    //             // centerMode: true, // type:boolean, default:false, Enables centered view with partial prev/next slides. Use with odd numbered slidesToShow counts.
    //             // centerPadding: '50px', // type:string, default:'50px', Side padding when in center mode (px or %)
    //             // cssEase: 'ease', // type:string, default:'ease', CSS3 Animation Easing
    //             // customPaging: n/a, // type:function, default:n/a, Custom paging templates. See source for use example.
    //             dots: false, // type:boolean, default:false, Show dot indicators
    //             // dotsClass: 'slick-dots', // type:string, default:'slick-dots', Class for slide indicator dots container
    //             // draggable: true, // type:boolean, default:true, Enable mouse dragging
    //             // fade: false, // type:boolean, default:false, Enable fade
    //             // focusOnSelect: false, // type:boolean, default:false, Enable focus on selected element (click)
    //             // easing: 'linear', // type:string, default:'linear', Add easing for jQuery animate. Use with easing libraries or default easing methods
    //             // edgeFriction: 0.15, // type:integer, default:0.15, Resistance when swiping edges of non-infinite carousels
    //             // infinite: true, // type:boolean, default:true, Infinite loop sliding
    //             // initialSlide: 0, // type:integer, default:0, Slide to start on
    //             // lazyLoad: 'ondemand', // type:string, default:'ondemand', Set lazy loading technique. Accepts 'ondemand' or 'progressive' To use lazy loading, set a data-lazy attribute on your img tags and leave off the src
    //             mobileFirst: true, // type:boolean, default:false, Responsive settings use mobile first calculation
    //             // pauseOnFocus: true, // type:boolean, default:true, Pause Autoplay On Focus
    //             // pauseOnHover: true, // type:boolean, default:true, Pause Autoplay On Hover
    //             // pauseOnDotsHover: false, // type:boolean, default:false, Pause Autoplay when a dot is hovered
    //             // respondTo: 'window', // type:string, default:'window', Width that responsive object responds to. Can be 'window', 'slider' or 'min' (the smaller of the two)
    //             // responsive: none, // type:object, default:none, Object containing breakpoints and settings objects (see demo). Enables settings sets at given screen width. Set settings to "unslick" instead of an object to disable slick at a given breakpoint.
    //             // responsive: [
    //             // 	{
    //             // 		breakpoint: 481, // medium up
    //             // 		settings: {
    //             // 			slidesToShow: 3,
    //             // 		}
    //             // 	},
    //             // 	{
    //             // 		breakpoint: 769, // large up
    //             // 		settings: {
    //             // 			slidesToShow: 4,
    //             // 		}
    //             // 	},
    //             // ],
    //             // rows: 1, // type:int, default:1, Setting this to more than 1 initializes grid mode. Use slidesPerRow to set how many slides should be in each row.
    //             // slide: '', // type:element, default:'', Element query to use as slide
    //             // slidesPerRow: 1, // type:int, default:1, With grid mode intialized via the rows option, this sets how many slides are in each grid row. dver
    //             slidesToShow: 2, // type:int, default:1, # of slides to show
    //             // slidesToScroll: 1, // type:int, default:1, # of slides to scroll
    //             // speed: 300, // type:int(ms), default:300, Slide/Fade animation speed
    //             // swipe: true, // type:boolean, default:true, Enable swiping
    //             // swipeToSlide: false, // type:boolean, default:false, Allow users to drag or swipe directly to a slide irrespective of slidesToScroll
    //             // touchMove: true, // type:boolean, default:true, Enable slide motion with touch
    //             // touchThreshold: 5, // type:int, default:5, To advance slides, the user must swipe a length of (1/touchThreshold) * the width of the slider
    //             // useCSS: true, // type:boolean, default:true, Enable/Disable CSS Transitions
    //             // useTransform: true, // type:boolean, default:true, Enable/Disable CSS Transforms
    //             // variableWidth: false, // type:boolean, default:false, Variable width slides
    //             // vertical: false, // type:boolean, default:false, Vertical slide mode
    //             // verticalSwiping: false, // type:boolean, default:false, Vertical swipe mode
    //             // rtl: false, // type:boolean, default:false, Change the slider's direction to become right-to-left
    //             // waitForAnimate: true, // type:boolean, default:true, Ignores requests to advance the slide while animating
    //             // zIndex: 1000, // type:number, default:1000, Set the zIndex values for slides, useful for IE9 and lower
    //         });
    //     }
    // });   

    var $lt_tabs = jQuery('.lt-tabs');
    
    $lt_tabs.slick({
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.lt-selectors'
    });
    var $lt_selectors = jQuery('.lt-selectors');
    $lt_selectors.slick({
        mobileFirst: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        asNavFor: '.lt-tabs',
        dots: false,
        centerMode: true,
        focusOnSelect: true,
        // responsive: none, // type:object, default:none, Object containing breakpoints and settings objects (see demo). Enables settings sets at given screen width. Set settings to "unslick" instead of an object to disable slick at a given breakpoint.
        // responsive: [
        // 	{
        // 		breakpoint: 481, // medium up
        // 		settings: {
        // 			slidesToShow: 3,
        // 		}
        // 	},
        // 	{
        // 		breakpoint: 769, // large up
        // 		settings: {
        // 			slidesToShow: 4,
        // 		}
        // 	},
        // ],
      });
} );

